import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import FlexView from 'react-flexview/lib';
import { GridResultsScreen } from './Grid/GridResultsScreen';
import {EuiFlexGroup,EuiFlexItem,EuiOverlayMask,EuiModal,EuiModalHeader,EuiModalHeaderTitle,EuiModalBody, EuiSpacer, EuiLoadingSpinner,EuiPanel,EuiText} from '@elastic/eui';
import FormularioContainer from './Formulario/container';
import { ActionType, VALIDAR, ESTADOS, USER_PERMISSIONS, DESVALIDAR } from './constants';
import {useUserSettings} from '../../context/CurrentUserContext';
import { Action } from '../../components/Menus/interface';
import { Menu } from '../../components/Menus';
import FiltrosMenu from '../../components/Menus/filtros';
import ModalYesNo from '../../components/Modal/YesNo';
import {AbonosPartesContainer as AbonosPartes} from './Abonos/container';
//import { Parte } from '../../../../infraestructure/persistence/rest/PartesAdapter';

interface Props {
  data: any;
  //handleUpdate(parte: any): any;
  handleFilter(filtro: any): any;
  handleValidar(idPartes: any, tipo:any): any;
  handleDesvalidar(idPartes: any, tipo:any): any;
  //handleAdjuntar(selected: any): any;
  //handleDownLoad(idsPartes: any): any;
  isLoading:boolean;
  location:any;
}

const ValidacionPartesScreen = (props: Props) => {
  const ref:any = useRef();
  let {currentUser}:any = useUserSettings();
  const permisosUser = useMemo(()=>{
    switch (currentUser.perfil) {
      case 'RAR':
        return USER_PERMISSIONS.RAR
      case 'FIS':
        return USER_PERMISSIONS.FIS
      case 'FAC':
        return USER_PERMISSIONS.FAC
      case 'ADM':
        return USER_PERMISSIONS.ADM
    }
  },[currentUser])
    

  let { data, handleFilter, handleValidar, handleDesvalidar, isLoading, location } = props;
  let [isModalVisible, setIsModalVisible] = useState(false);
  let [openConfirmModal, setOpenConfirmModal] = useState(false);
  let [selected, setSelected] = useState<any>([]);
  let [actionType, setActionType] = useState<ActionType>(VALIDAR);
  let [filtro, setFiltro] = useState<any>(undefined)
  let [codEstadoFiltered, setEstadoFiltered] = useState(ESTADOS.RESPONSABLE_AREA.codEstado);

  useEffect(() => {closeModal(false); if(openConfirmModal){setOpenConfirmModal(false)}}, [data]);

  useEffect(()=> {
    if(filtro){
      setEstadoFiltered(filtro.estado);
      filtrarPartes();
    }
  },[filtro])

  const getEstado = (tipo:string)=>{
    let find:any=undefined;
    const values: any = Object.values(ESTADOS)
    let i:number = 0;

    while (!find && i<values.length) {
      if((values[i] && values[i]['codEstado']) === codEstadoFiltered)
      {
        find= values[i][tipo];
      }
      i++;
    }
  
    return find;
  }

  // const prepareEdit = useCallback(() => {
  //   setActionType(UPDATE);
  //   showModal();
  // },[])

  // const prepareAdjuntar = useCallback(() => {
  //   setActionType(ADJUNTAR);
  //   showModal();
  // },[])

  const prepareValidar = useCallback(()=>{
    setActionType(VALIDAR);
    setOpenConfirmModal(true)
  },[])

  const prepareDesValidar = useCallback(()=>{
    setActionType(DESVALIDAR);
    setOpenConfirmModal(true)
  },[])

  const onValidar = useCallback(() => {
    const tipo:any = getEstado('tipoVal')
    if (selected && tipo) {
      handleValidar(selected, tipo)
    }
  },[selected, handleValidar])

  const onDesValidar = useCallback(() => {
    const tipo:any = getEstado('tipoDesv')
    if (selected && tipo) {
      handleDesvalidar(selected, tipo)
    }
  },[selected, handleDesvalidar])

  // const onUpdate = (newData: any) => {
  //   if (handleUpdate && newData) {
  //     handleUpdate(newData)
  //   }
  // }

  // const onAdjuntar = () => {
  //   if (selected && handleAdjuntar) {
  //     handleAdjuntar(selected);
  //   }
  // }
  
  const onExport = () =>{
    ref && ref.current.onExport();
  }

  const onFilterClear = () => { 
    ref.current && ref.current.onFilterClear()
  }

  const onSelected = (selection: any) => {
    setSelected([...selection])
  }

  const filtroInicial = (filtro:any)=>{
    onChangeFilter(filtro);
  }

  const filtrarPartes = () => {
    handleFilter(filtro)
  }

  const onChangeFilter = (filter:any)=>{
    const newFilter = filter//filter : {...filter, ...{filterDrillDown:location.state.filter, estado:5}}
    setFiltro(newFilter);
    if(filtro===undefined){
      handleFilter && handleFilter(newFilter)
    }
  }

  const getSelected = () =>{
    switch (actionType.tipo) {
      case 'I':return undefined;
      case 'U':return selected[0];
      //case 'A':return selected;
    }
  }

  const closeModal = (refresh:boolean) => { if(refresh && actionType.tipo==="U"){ filtrarPartes();}setIsModalVisible(false)};
  const showModal = () => setIsModalVisible(true);

  const getHandle = () =>{
    switch (actionType.tipo) {
      case 'V':return onValidar;
      case 'D':return onDesValidar;
      //case 'U':return onUpdate;
      //case 'A':return onAdjuntar;
      default : return onValidar;
    }
  }

  const onConfirm = (response:any) => {
    if(response!==undefined && response === true){
      switch (actionType.tipo) {
        case 'V':return onValidar();
        case 'D':return onDesValidar();
      }
    }else{
      setOpenConfirmModal(false)
    }
  }

  // const isDisabledAdjuntar = useCallback(() => {
  //   const adj = permisosUser && permisosUser.adjuntar.includes(codEstadoFiltered);
  //   return (selected.length>0 && adj ? false : true)
  // },[selected,codEstadoFiltered,permisosUser])

  // const isDisabledEditar = useCallback(() => {
  //   const edit = permisosUser && permisosUser.editar.includes(codEstadoFiltered);
  //   const selectedPermissions = (selected.length === 1 && selected[0].facturado===false)
  //   return (selectedPermissions && edit ? false : true)
  // },[selected,codEstadoFiltered,permisosUser])

  const isDisabledValidar = useCallback(() => { 
    const val = permisosUser && (permisosUser.validar.includes(codEstadoFiltered));
    return (selected.length>0 && val ? false : true)
  },[selected,codEstadoFiltered,permisosUser])

  const isDisabledDesValidar = useCallback(() => { 
    const val = permisosUser && permisosUser.desvalidar.includes(codEstadoFiltered);
    return (selected.length>0 && val ? false : true)
  },[selected,codEstadoFiltered,permisosUser])

  const Actions = useMemo(():Action[] => [
    {handle:onFilterClear,text:"Limpiar Filtro",size:"s", isDisabled: false, className: "btnFilterClear"},
    {handle:onExport,text:"Exportar",size:"s", isDisabled:false},
    {component:<AbonosPartes color="warning" size="s" partes={selected} refresh={filtrarPartes}/>},
    // {handle:prepareAdjuntar,text:"Adjuntar",size:"s", isDisabled:isDisabledAdjuntar(), className: (isDisabledAdjuntar() ? "btnDisabled" : "btnAdjuntar")},
    // {handle:prepareEdit,text:"Editar",color:"secondary",size:"s",isDisabled:isDisabledEditar()},
    {handle:prepareDesValidar,text:`Desvalidar (${selected.length})`,color:"primary",size:"s", isDisabled:isDisabledDesValidar()},
    {handle:prepareValidar,text:`Validar (${selected.length})`,color:"primary",size:"s", isDisabled:isDisabledValidar()}
  ],[prepareValidar,isDisabledValidar,prepareDesValidar,isDisabledDesValidar])

  let modal = (
    <>
    <div className={isLoading?'maskLoad':'hidden'}>
      <EuiPanel grow={false}>
        <EuiFlexItem>
        <EuiLoadingSpinner size="xl"/>
      </EuiFlexItem>
      <EuiFlexItem>
      <EuiText textAlign='center' size='m'>{`Realizando operación....`}</EuiText>
      </EuiFlexItem>
      </EuiPanel>
    </div>
    <EuiOverlayMask>
      <EuiModal onClose={()=>closeModal(true)} style={{ width:"50vw"}} maxWidth={false}>
        <EuiModalHeader>
          <EuiModalHeaderTitle>{actionType.title}</EuiModalHeaderTitle>
        </EuiModalHeader>
        <EuiModalBody>
          <FormularioContainer tipo={actionType.tipo} handle={getHandle()} selected={getSelected()} onClose={closeModal} 
          perfilUser={currentUser.perfil} user={currentUser}/>
        </EuiModalBody>
      </EuiModal>
    </EuiOverlayMask>
    </>
    );

    const MaskLoad = useMemo(()=>{
      return isLoading ?
      <div className={'maskLoad'}>
        <EuiPanel grow={false}>
          <EuiFlexItem>
          <EuiLoadingSpinner size="xl"/>
        </EuiFlexItem>
        <EuiFlexItem>
        <EuiText textAlign='center' size='m'>{`Realizando operación....`}</EuiText>
        </EuiFlexItem>
        </EuiPanel>
      </div>
      :null
    },[isLoading])

    let modalConfirm = (
      <>
        <ModalYesNo onClose={onConfirm} isOpen={openConfirmModal} action={actionType.action}/>
      </>
      );

  const getView = () => {
    return (
      <>
        <GridResultsScreen
          data={data}
          selector={false}
          selected={selected}
          onSelected={onSelected}
          onChange={()=>{}}
          ref={ref}
        />
        {MaskLoad}
        {isModalVisible ? modal : null}
        {openConfirmModal ? modalConfirm : null}
      </>
    )
  }

  return (
    <FlexView column basis="100%">
        <EuiFlexGroup gutterSize="s" alignItems="center" className="wrapperMenuPage">
          <EuiFlexGroup alignItems={'center'} justifyContent="flexStart" className="filter">
            <FiltrosMenu selectorEstado filtroInicial = {filtroInicial} dateInit onChangeFilter={onChangeFilter} otherFilters={location.state.filter}/>
          </EuiFlexGroup>
          <Menu actions={Actions} className="actions"/>
         </EuiFlexGroup>
        <EuiSpacer size="m" />
      <FlexView grow={1} shrink={1} basis="auto">
        <FlexView column shrink={0} basis="100%">
          {getView()}
        </FlexView>
      </FlexView>
    </FlexView>
  );
};

export default ValidacionPartesScreen;
